import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { CARBON_OFFSET_SUPPLIERS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchSuppliers = () => {
  return useQuery({
    queryKey: [CARBON_OFFSET_SUPPLIERS_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/suppliers",
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};
